import ViewEditAttachmentsModal from "./ViewEditAttachmentsModalContainer";

export default ViewEditAttachmentsModal;
